// Функция, которая заменяем передаваемый текст на звездочки
// Принимает исходный текст и маты

export const getMutedSwearWords = (userText, swearWordsArray, regExpSwearWords) => {
    const newUserText = userText
    if (swearWordsArray.length === 0 && !regExpSwearWords) return newUserText
    if ( !newUserText) return newUserText
    const changedUserText = newUserText.replaceAll(regExpSwearWords, " *** ").replaceAll(regExpSwearWords, " *** ")

    return changedUserText
}